if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"inboxApp","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(20(|3)|103|155|567|642|904|932)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}